"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.useTest = exports.useFeature = exports.loadSession = exports.context = exports.DarwinProvider = exports.Consumer = void 0;

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SESSION_KEY = "__kwd_tests";

var loadSession = function loadSession() {
  try {
    var raw = sessionStorage.getItem(SESSION_KEY);

    if (raw === null) {
      return {};
    }

    return JSON.parse(raw);
  } catch (e) {
    return {
      __error: String(e)
    }; // Differenciates between error and empty state
  }
};

exports.loadSession = loadSession;

var saveSession = function saveSession(test) {
  var _extends2;

  var current = loadSession();
  sessionStorage.setItem(SESSION_KEY, JSON.stringify((0, _extends3.default)({}, current, (_extends2 = {}, _extends2[test.name] = test.value, _extends2))));
};

var context = /*#__PURE__*/React.createContext({
  onTest: function onTest() {
    return null;
  },
  onFeature: function onFeature() {
    return false;
  }
});
exports.context = context;
var Provider = context.Provider,
    Consumer = context.Consumer;
exports.Consumer = Consumer;

var DarwinProvider = function DarwinProvider(_ref) {
  var tests = _ref.tests,
      _ref$features = _ref.features,
      features = _ref$features === void 0 ? {} : _ref$features,
      _ref$winners = _ref.winners,
      winners = _ref$winners === void 0 ? [] : _ref$winners,
      onTest = _ref.onTest,
      children = _ref.children;
  var handleTest = React.useCallback(function (name) {
    var winner = winners.find(function (w) {
      return w.name === name;
    });

    if (winner != null) {
      return winner.value;
    } // Actual test visited


    var test = tests.find(function (t) {
      return t.name === name;
    });

    if (test == null) {
      return null;
    }

    if (typeof window !== "undefined" && !(name in loadSession())) {
      saveSession(test);
      onTest === null || onTest === void 0 ? void 0 : onTest(test);
    }

    return test.value;
  }, [tests, winners, onTest]);
  var handleFeature = React.useCallback(function (name) {
    return name in features ? features[name] : false;
  }, [features]);
  return /*#__PURE__*/React.createElement(Provider, {
    value: {
      onTest: handleTest,
      onFeature: handleFeature
    }
  }, children);
};

exports.DarwinProvider = DarwinProvider;

var useDarwin = function useDarwin() {
  return React.useContext(context);
};

var useTest = function useTest(name) {
  var _useDarwin = useDarwin(),
      onTest = _useDarwin.onTest;

  return onTest(name);
};

exports.useTest = useTest;

var useFeature = function useFeature(name) {
  var _useDarwin2 = useDarwin(),
      onFeature = _useDarwin2.onFeature;

  return onFeature(name);
};

exports.useFeature = useFeature;